module.exports = __webpack_public_path__ + "img/2-dash.822b8069.png";